import React from 'react';
import './LessonFooter.css';

/**
 * Site-wide footer, rendered once in the app shell so every page closes with
 * the same bar. Colours are hardcoded locally instead of taken from the
 * lesson tokens, which are scoped to .lesson-page and would not reach here.
 */
const LessonFooter = () => {
  return (
    <footer className="lesson-footer">
      <div className="lesson-footer__inner">
        <div className="lesson-footer__brand">
          <span className="lesson-footer__logo">EEE</span>
          <span>English Exam Exercises</span>
        </div>
        <span className="lesson-footer__copy">
          © 2026 — Language Learning Roadmap
        </span>
      </div>
    </footer>
  );
};

export default LessonFooter;